import React, { useEffect, useState } from "react";
import { TopBar } from "../components/topBar";
import {
  isLoggedInVar,
  pageIndicator,
  serviceId,
  serviceName,
} from "../apollo";
import {
  Button,
  CircularProgress,
  Dialog,
  Slide,
  Snackbar,
} from "@mui/material";
import moment from "moment";
import backwardArrow from "../assets/icons/backwardArrow.svg";
import arrow from "../assets/icons/arrow_right.svg";
import { useNavigate, useParams } from "react-router-dom";
import star_yellow from "../assets/icons/star_yellow.svg";
import star_gray from "../assets/icons/star_gray.svg";
import { FootMenu } from "../components/FootMenu";
import { useListGoodReview } from "../hooks/useListGoodReview";
import { emailMasking } from "../constants/returnFunction";
import { useMe } from "../hooks/useME";
import { ListGoodReviewInput, ListGoodReviewQuery } from "../gql/graphql";
import { State } from "./good-detail";
import {
  ListCouponLocationQuery,
  useListCouponLocation,
} from "../hooks/useListCouponLocation";
import { useReactiveVar } from "@apollo/client";
import {
  CrUserCouponMutation,
  useCrUserCoupon,
} from "../hooks/useCrUserCoupon";
import { CouponStatus, UserCouponStatus } from "../constants/props";
import { AlertComponent } from "../components/alert";
export interface dateFilterBtnList {
  text: string;
  active: boolean;
}

export const ListCoupon = () => {
  const navigate = useNavigate();
  const [alertOpen, setAlertOpen] = useState(false);
  const closeModal = () => {
    setAlertOpen(false);
  };
  const coupon_serviceId = useReactiveVar(serviceId);
  const coupon_serviceName = useReactiveVar(serviceName);
  const isLoggedIn = useReactiveVar(isLoggedInVar);
  const { data: me } = useMe();
  const [listCoupon, setListCoupon] = useState<
    ListCouponLocationQuery["listCouponLocation"]["coupons"]
  >([]);
  // list coupon
  const onListCompleted = (data: ListCouponLocationQuery) => {
    console.log(data, "data");
    if (data.listCouponLocation.ok && data.listCouponLocation.coupons) {
      setListCoupon(data.listCouponLocation.coupons);
    }
  };
  const [listCouponLocation, { loading: listCouponLocationLoading }] =
    useListCouponLocation(onListCompleted);

  const listCouponHandler = () => {
    if (coupon_serviceId) {
      listCouponLocation({
        variables: {
          input: {
            serviceId: coupon_serviceId,
            userId: me?.me ? me.me.id : undefined,
          },
        },
      });
    }
  };

  useEffect(() => {
    if (coupon_serviceId && coupon_serviceId > 0) {
      listCouponHandler();
    }
  }, [me, coupon_serviceId]);
  //  쿠폰 발급
  const onCrUserCouponCompleted = (data: CrUserCouponMutation) => {
    if (data.crUserCoupon.ok) {
      setState({ ...state, open: true });
      listCouponHandler();
    }
  };
  const [createCoupon, { loading: createCouponLoading }] = useCrUserCoupon(
    onCrUserCouponCompleted
  );

  const createCouponHandler = (couponId: any) => {
    if (me?.me) {
      createCoupon({
        variables: {
          input: {
            couponId: Number(couponId),
            userId: Number(me.me.id),
          },
        },
      });
    }
  };
  // snack bar
  const [state, setState] = useState<State>({
    open: false,
  });
  const { open } = state;

  const handleClose = () => {
    setState({ ...state, open: false });
  };
  const snacks = (
    <React.Fragment>
      <Button onClick={handleClose}>닫기</Button>
    </React.Fragment>
  );
  return (
    <div className="h-full relative flex flex-wrap flex-col bg-bg">
      <header className="border-b">
        <TopBar arrow={true} home={true} heading={true} exit={true} />
      </header>
      <main className="w-full p-4 flex-1 overflow-auto pb-[72px] space-y-4">
        <div className="flex flex-wrap content-center justify-between">
          <h3 className="text-large font-bold">
            쿠폰 목록 - {coupon_serviceName}
          </h3>
        </div>
        {/*쿠폰 리스트 박스 */}
        <div className="listCoupon flex flex-col w-full gap-y-10 px-4 h-full pb-10">
          {listCouponLocationLoading ? (
            <div className="flex justify-center items-center h-full">
              <CircularProgress />
            </div>
          ) : (
            // isAvailable 쿠폰 먼저 출력
            listCoupon
              .filter((coupon) => coupon.isAvailable)
              .map(
                (
                  coupon: ListCouponLocationQuery["listCouponLocation"]["coupons"][0],
                  index: number
                ) => (
                  <div
                    key={`coupon-${coupon.coupon.id}-${index}`}
                    className="couponBox"
                  >
                    <div
                      className={`topEdge ${
                        !coupon.userCouponId
                          ? "bg-mainIcon border-mainIcon"
                          : "bg-hintFont border-hintFont"
                      } w-full h-4 border  rounded-t-lg border-b-0`}
                    ></div>
                    <div
                      className={`coupone-contents text-center p-4 border border-grayFont rounded-b-lg border-t-0 flex flex-col gap-y-2 ${
                        !coupon.userCouponId
                          ? "text-black font-bold"
                          : "text-grayFont"
                      }`}
                    >
                      <p
                        className={`font-bold text-lg ${
                          !coupon.userCouponId ? "text-black" : "text-grayFont"
                        }`}
                      >
                        {coupon.coupon.name}
                      </p>
                      <p
                        className={`text-lg font-bold py-2 ${
                          !coupon.userCouponId
                            ? "text-mainIcon"
                            : "text-grayFont"
                        }`}
                      >
                        ✨ {coupon.coupon.discountPrice}원 할인 쿠폰 ✨
                      </p>
                      <p className="text-grayFont text-sm">
                        이용기간 :{" "}
                        {moment(coupon.coupon.validFrom).format("YYYY-MM-DD")}~{" "}
                        {moment(coupon.coupon.validUntil).format("YYYY-MM-DD")}
                      </p>
                      <button
                        onClick={() => {
                          if (!isLoggedIn) {
                            setAlertOpen(true);
                            return;
                          }
                          if (!coupon.userCouponId) {
                            createCouponHandler(coupon.coupon.id);
                          }
                        }}
                        disabled={coupon.userCouponId ? true : false}
                        className={`bg-mainIcon text-white rounded-md py-1 text-lg font-bold w-36 mx-auto ${
                          !coupon.userCouponId ? "bg-mainIcon" : "bg-grayFont"
                        }`}
                      >
                        {coupon.userCouponId ? "발급완료" : "쿠폰받기"}
                      </button>
                    </div>
                  </div>
                )
              )
          )}
          {listCoupon.length === 0 && (
            <div className="flex justify-center items-center h-full">
              <p className="text-grayFont text-sm">지금은 쿠폰이 없어요!</p>
            </div>
          )}
        </div>
      </main>
      {/* loading */}
      {/* <div className="absolute left-0 top-0 w-full h-full bg-black bg-opacity-20"></div> */}
      <FootMenu />
      <Snackbar
        open={open}
        autoHideDuration={3000}
        anchorOrigin={{ horizontal: "center", vertical: "bottom" }}
        onClose={handleClose}
        message={"쿠폰이 발급되었습니다."}
        action={snacks}
      ></Snackbar>
      <Dialog
        open={alertOpen}
        onClose={() => {
          setAlertOpen(false);
        }}
      >
        <AlertComponent
          title={`안내`}
          desc={`로그인/회원가입 후 발급 가능합니다.`}
          closeFunction={closeModal}
        ></AlertComponent>
      </Dialog>
    </div>
  );
};
